/**
 * * Actions for Company Admin Panel
 */
import axios from '../../../../redux/apiCaller';
import { attemptAction, successAction, errorAction } from '../../../../redux/constants';

import {
  FETCHCOMPANY_ATTEMPT,
  FETCHCOMPANY_SUCCESS,
  FETCHCOMPANY_FAIL,
  UPDATECOMPANY_ATTEMPT,
  UPDATECOMPANY_SUCCESS,
  UPDATECOMPANY_FAIL,
  GENERATECREDENTIALS_ATTEMPT,
  GENERATECREDENTIALS_SUCCESS,
  GENERATECREDENTIALS_FAIL,
  SETCOMPANY,
  SETUSER,
  SETGROUPUSERS,
  SETGROUP,
  UPLOADLOGO_ATTEMPT,
  UPLOADLOGO_SUCCESS,
  UPLOADLOGO_FAIL,
  GETUSERS_ATTEMPT,
  GETUSERS_SUCCESS,
  GETUSERS_FAIL,
  FETCHGROUPS_ATTEMPT,
  FETCHGROUPS_SUCCESS,
  FETCHGROUPS_FAIL,
  ADDUSER_ATTEMPT,
  ADDUSER_SUCCESS,
  ADDUSER_FAIL,
  UPDATEUSER_ATTEMPT,
  UPDATEUSER_SUCCESS,
  UPDATEUSER_FAIL,
  DELETEUSER_ATTEMPT,
  DELETEUSER_SUCCESS,
  DELETEUSER_FAIL,
  ADDGROUP_ATTEMPT,
  ADDGROUP_SUCCESS,
  ADDGROUP_FAIL,
  UPDATEGROUP_ATTEMPT,
  UPDATEGROUP_FAIL,
  UPDATEGROUP_SUCCESS,
  DELETEGROUP_ATTEMPT,
  DELETEGROUP_FAIL,
  DELETEGROUP_SUCCESS,
  RESETPWD_ATTEMPT,
  RESETPWD_SUCCESS,
  RESETPWD_FAIL,
  GETPACKAGES_ATTEMPT,
  GETPACKAGES_SUCCESS,
  GETPACKAGES_FAIL,
  FETCHCARDS_ATTEMPT,
  FETCHCARDS_SUCCESS,
  FETCHCARDS_FAIL,
  ADDCARD_ATTEMPT,
  ADDCARD_SUCCESS,
  ADDCARD_FAIL,
  UPDATECARD_ATTEMPT,
  UPDATECARD_SUCCESS,
  UPDATECARD_FAIL,
  DELETECARD_ATTEMPT,
  DELETECARD_SUCCESS,
  DELETECARD_FAIL,
  CREATEPURCHASE_ATTEMPT,
  CREATEPURCHASE_SUCCESS,
  CREATEPURCHASE_FAIL,
  UPDATEPURCHASE_ATTEMPT,
  UPDATEPURCHASE_SUCCESS,
  UPDATEPURCHASE_FAIL,
  SETADMINALERT,
  SETDEFAULTCARD_ATTEMPT,
  SETDEFAULTCARD_SUCCESS,
  SETDEFAULTCARD_FAIL,
  FETCHACTIVESUBSCRIPTION_ATTEMPT,
  FETCHACTIVESUBSCRIPTION_SUCCESS,
  FETCHACTIVESUBSCRIPTION_FAIL,
  CANCELSUBSCRIPTION_ATTEMPT,
  CANCELSUBSCRIPTION_SUCCESS,
  CANCELSUBSCRIPTION_FAIL,
  REACTIVATESUBSCRIPTION_ATTEMPT,
  REACTIVATESUBSCRIPTION_SUCCESS,
  REACTIVATESUBSCRIPTION_FAIL,
} from '../constants';

export const uploadPicture = (file) => {
  const data = new FormData();
  data.append('file', file);
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(UPLOADLOGO_ATTEMPT));
      const body = await axios.post(`/uploader/upload-single`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      dispatch(successAction(UPLOADLOGO_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(UPLOADLOGO_FAIL, err));
    }
  };
  return thunk;
};

export const getCompany = () => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(FETCHCOMPANY_ATTEMPT));
      const body = await axios.get(`admin/company`);
      dispatch(successAction(FETCHCOMPANY_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(FETCHCOMPANY_FAIL, err));
    }
  };
  return thunk;
};

export const saveCompany = (data) => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(UPDATECOMPANY_ATTEMPT));
      const body = await axios.post(`admin/company`, data);
      dispatch(successAction(UPDATECOMPANY_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(UPDATECOMPANY_FAIL, err));
    }
  };
  return thunk;
};

export const generateCredentials = () => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(GENERATECREDENTIALS_ATTEMPT));
      const body = await axios.post(`admin/company/generate-credentials`);
      dispatch(successAction(GENERATECREDENTIALS_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(GENERATECREDENTIALS_FAIL, err));
    }
  };
  return thunk;
};

export const setCompany = (data) => {
  const thunk = async function thunk(dispatch) {
    dispatch(successAction(SETCOMPANY, data));
  };
  return thunk;
};

export const setUser = (data) => {
  const thunk = async function thunk(dispatch) {
    dispatch(successAction(SETUSER, data));
  };
  return thunk;
};

export const setGroupUsers = (data) => {
  const thunk = async function thunk(dispatch) {
    dispatch(successAction(SETGROUPUSERS, data));
  };
  return thunk;
};

export const setGroup = (data) => {
  const thunk = async function thunk(dispatch) {
    dispatch(successAction(SETGROUP, data));
  };
  return thunk;
};

export const fetchGroups = () => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(FETCHGROUPS_ATTEMPT));
      const body = await axios.get(`admin/management/getGroups`);
      dispatch(successAction(FETCHGROUPS_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(FETCHGROUPS_FAIL, err));
    }
  };
  return thunk;
};

export const fetchUsers = () => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(GETUSERS_ATTEMPT));
      const body = await axios.get(`admin/users`);
      dispatch(successAction(GETUSERS_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(GETUSERS_FAIL, err));
    }
  };
  return thunk;
};

export const addUser = (data) => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(ADDUSER_ATTEMPT));
      const body = await axios.post(`admin/users`, data);
      dispatch(successAction(ADDUSER_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(ADDUSER_FAIL, err));
    }
  };
  return thunk;
};

export const updateUser = (id, data) => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(UPDATEUSER_ATTEMPT));
      const body = await axios.post(`admin/users/${id}`, data);
      dispatch(successAction(UPDATEUSER_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(UPDATEUSER_FAIL, err));
    }
  };
  return thunk;
};

export const resetPassword = (id, data) => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(RESETPWD_ATTEMPT));
      const body = await axios.post(`admin/users/${id}/sendResetLink`, data);
      dispatch(successAction(RESETPWD_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(RESETPWD_FAIL, err));
    }
  };
  return thunk;
};

export const deleteUser = (id) => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(DELETEUSER_ATTEMPT));
      const body = await axios.delete(`admin/users/${id}`);
      dispatch(successAction(DELETEUSER_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(DELETEUSER_FAIL, err));
    }
  };
  return thunk;
};

export const addGroup = (data) => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(ADDGROUP_ATTEMPT));
      const body = await axios.post(`admin/groups`, data);
      dispatch(successAction(ADDGROUP_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(ADDGROUP_FAIL, err));
    }
  };
  return thunk;
};

export const updateGroup = (id, data) => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(UPDATEGROUP_ATTEMPT));
      const body = await axios.post(`admin/groups/${id}`, data);
      dispatch(successAction(UPDATEGROUP_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(UPDATEGROUP_FAIL, err));
    }
  };
  return thunk;
};

export const deleteGroup = (id) => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(DELETEGROUP_ATTEMPT));
      const body = await axios.delete(`admin/groups/${id}`);
      dispatch(successAction(DELETEGROUP_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(DELETEGROUP_FAIL, err));
    }
  };
  return thunk;
};

export const fetchPackages = () => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(GETPACKAGES_ATTEMPT));
      const body = await axios.get(`admin/packages`);
      dispatch(successAction(GETPACKAGES_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(GETPACKAGES_FAIL, err));
    }
  };
  return thunk;
};

export const setAdminAlert = (data) => {
  const thunk = async function thunk(dispatch) {
    dispatch(successAction(SETADMINALERT, data));
  };
  return thunk;
};

export const fetchCards = () => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(FETCHCARDS_ATTEMPT));
      const body = await axios.post(`admin/company/fetchCards`, {});
      dispatch(successAction(FETCHCARDS_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(FETCHCARDS_FAIL, err));
    }
  };
  return thunk;
};

export const addCard = (data) => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(ADDCARD_ATTEMPT));
      const body = await axios.post(`admin/company/addCard`, data);
      dispatch(successAction(ADDCARD_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(ADDCARD_FAIL, err));
    }
  };
  return thunk;
};

export const updateCard = (data) => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(UPDATECARD_ATTEMPT));
      const body = await axios.post(`admin/company/updateCard`, data);
      dispatch(successAction(UPDATECARD_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(UPDATECARD_FAIL, err));
    }
  };
  return thunk;
};

export const setDefaultCard = (data) => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(SETDEFAULTCARD_ATTEMPT));
      const body = await axios.post(`admin/company/setAsDefault`, data);
      dispatch(successAction(SETDEFAULTCARD_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(SETDEFAULTCARD_FAIL, err));
    }
  };
  return thunk;
};

export const deleteCard = (data) => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(DELETECARD_ATTEMPT));
      const body = await axios.post(`admin/company/deleteCard`, data);
      dispatch(successAction(DELETECARD_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(DELETECARD_FAIL, err));
    }
  };
  return thunk;
};

export const createPurchase = (data) => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(CREATEPURCHASE_ATTEMPT));
      const body = await axios.post(`admin/payment/create-subscription`, data);
      dispatch(successAction(CREATEPURCHASE_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(CREATEPURCHASE_FAIL, err));
    }
  };
  return thunk;
};

export const fetchSubscription = (data) => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(FETCHACTIVESUBSCRIPTION_ATTEMPT));
      const body = await axios.post(`admin/payment/retrieve-subscription-information`, data);
      dispatch(successAction(FETCHACTIVESUBSCRIPTION_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(FETCHACTIVESUBSCRIPTION_FAIL, err));
    }
  };
  return thunk;
};

export const updatePurchase = (data, type = 'qty') => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(UPDATEPURCHASE_ATTEMPT));
      const body = await axios.post(
        type === 'qty' ? `admin/payment/update-subscription-qty` : `admin/payment/update-subscription-interval`,
        data,
      );
      dispatch(successAction(UPDATEPURCHASE_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(UPDATEPURCHASE_FAIL, err));
    }
  };
  return thunk;
};

export const cancelSubscription = () => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(CANCELSUBSCRIPTION_ATTEMPT));
      const body = await axios.post(`admin/payment/cancel-subscription`);
      dispatch(successAction(CANCELSUBSCRIPTION_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(CANCELSUBSCRIPTION_FAIL, err));
    }
  };
  return thunk;
};

export const reactivateSubscription = () => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(REACTIVATESUBSCRIPTION_ATTEMPT));
      const body = await axios.post(`admin/payment/reactivate-subscription`);
      dispatch(successAction(REACTIVATESUBSCRIPTION_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(REACTIVATESUBSCRIPTION_FAIL, err));
    }
  };
  return thunk;
};

export const retrySubscription = () => {
  const thunk = async function thunk(dispatch) {
    try {
      dispatch(attemptAction(REACTIVATESUBSCRIPTION_ATTEMPT));
      const body = await axios.post(`admin/payment/retry-subscription`);
      dispatch(successAction(REACTIVATESUBSCRIPTION_SUCCESS, body.data));
    } catch (err) {
      dispatch(errorAction(REACTIVATESUBSCRIPTION_FAIL, err));
    }
  };
  return thunk;
};
